const JobCardStatus = ({ status }) => {
  return (
    <p
      className={`px-4 py-2 ${
        status ? "text-green-3" : "text-sky-600"
      }`}
    >
      {status ? "Completed" : "In Progress"}
    </p>
  );
};

export default JobCardStatus;